
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/senco-di-wedding",
      function () {
        return require("private-next-pages/senco-di-wedding/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/senco-di-wedding"])
      });
    }
  